import { ChangeDetectorRef, Component, OnInit,ElementRef,  ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CallService } from 'src/app/services/call.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { environment } from '../../../environments/environment';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FacPopupComponent } from '../fac-popup/fac-popup.component';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfirmService } from 'src/app/services/app-confirm/app-confirm.service';
import { RsaEncryptionService } from 'src/app/core/services/rsa-encryption.service';

declare var jQuery: any;

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.css'],
    standalone: false
})
export class FormComponent implements OnInit {

  // @ViewChild('myFormPost') myFormPost: ElementRef;
  basicForm: UntypedFormGroup;
  public HOST: string = environment.backendUrl;
  signedID : any; // ID DE SIGNED URL - INFORMACION  DE CLIENTE ENVIANDA EN JSON
  token : any; // TOKEN DE SEGURIDAD
  cc : any; // ID DEL TOKEN EN NUESTRA PLATAFORMA
  signature : any; // FIRMA GENERADA PARA ENVIAR
  merchantUrl : any; // URL A LA QUE HAY QUE ENVIAR LA RESPUESTA
  tokenTdc : any ; // TOKEN DE LA TDC QUE SE GENERO
  reference : any ; // REFERENCIA ENVIADA POR EL CLIENTE PARA EL PROCESO
  plan : any; // ID DEL PLAN AL QUE SE ESTA SUSCRIBIENDO EL CLIENTE
  jsonEncoded : any ;// JSON QUE SE ENVIARA AL CLIENTE
  signatureCalculated: any // FIRMA QUE SE GENERA EN BASE AL JSON
  identificator : string = '';
  currentYear: number = new Date().getFullYear();
  footerRightsByIdentificator: {[key: string]: string} = {
    panapark: `Panapark Free Zone © ${new Date().getFullYear()}`
  };

  clientForm : UntypedFormGroup;
  expirationYears: Array<{value: string, label: string}> = [];


  constructor( private cdr: ChangeDetectorRef,public confirmService: AppConfirmService,private call: CallService,private sanitizer: DomSanitizer, private dialog: MatDialog, private activatedRoute: ActivatedRoute, private spinner : SpinnerService, private rsaEncryption: RsaEncryptionService) {
    this.basicForm = new UntypedFormGroup({
      numberCreditCard: new UntypedFormControl('', [
        Validators.required,
        this.cardNumberValidator.bind(this),
        this.luhnValidator.bind(this)
      ]),
      nameHolderCreditCard : new UntypedFormControl('', [Validators.required, this.cardHolderNameValidator.bind(this)]),
      expMonthCreditCard: new UntypedFormControl('', Validators.required),
      expYearCreditCard: new UntypedFormControl('', Validators.required),
      ccv: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^\d{3,4}$/)
      ])
    }, { validators: this.expirationDateValidator });

    this.clientForm = new UntypedFormGroup({
      Ds_SignatureVersion: new UntypedFormControl('HMAC_SHA256_V1'),
      Ds_MerchantParameters: new UntypedFormControl('',Validators.required),
      Ds_Signature: new UntypedFormControl('',Validators.required)
    });
   }

  ngOnInit(): void {

    this.generateExpirationYears();
    this.spinner.open();

    this.activatedRoute.queryParams.subscribe(querys =>{ // TOMAMOS EL TOKEN DE LA TDC
      this.token = querys.token;
      this.identificator = (querys.identificator || '').toLowerCase();
      this.activatedRoute.params.subscribe(param =>{ // TOMAMOS EL ID DEL SIGNED URL QUE TIENE LA INFORMACION EN BD

        this.signedID = param.id;
        this.spinner.close();

      });

    }, err =>{
      console.log(err);
    })


  }

  get footerRightsText(): string {
    return this.footerRightsByIdentificator[this.identificator] || `Todos los derechos reservados © ${this.currentYear}`;
  }

  generateExpirationYears(): void {
    const currentYear = new Date().getFullYear();
    const yearsToShow = 20; // Mostrar 20 años hacia adelante

    this.expirationYears = [];
    for (let i = 0; i < yearsToShow; i++) {
      const year = currentYear + i;
      const shortYear = year.toString().slice(-2); // Últimos 2 dígitos
      this.expirationYears.push({
        value: shortYear,
        label: year.toString()
      });
    }
  }

  expirationDateValidator(formGroup: UntypedFormGroup) {
    const monthControl = formGroup.get('expMonthCreditCard');
    const yearControl = formGroup.get('expYearCreditCard');
    const month = monthControl?.value;
    const year = yearControl?.value;

    if (!month || !year) {
      // Limpiar errores si no hay valores completos
      if (monthControl?.hasError('expiredDate')) {
        monthControl.setErrors(null);
      }
      if (yearControl?.hasError('expiredDate')) {
        yearControl.setErrors(null);
      }
      return null;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() devuelve 0-11

    // Convertir el año corto (26) a año completo (2026)
    const fullYear = parseInt('20' + year);
    const selectedMonth = parseInt(month);

    // Verificar si la fecha ya pasó
    if (fullYear < currentYear || (fullYear === currentYear && selectedMonth < currentMonth)) {
      // Marcar ambos controles con error para que se pongan en rojo
      monthControl?.setErrors({ expiredDate: true });
      yearControl?.setErrors({ expiredDate: true });
      return { expiredDate: true };
    }

    // Limpiar errores si la fecha es válida
    if (monthControl?.hasError('expiredDate')) {
      monthControl.setErrors(null);
    }
    if (yearControl?.hasError('expiredDate')) {
      yearControl.setErrors(null);
    }

    return null;
  }

  cardHolderNameValidator(control: AbstractControl): ValidationErrors | null {
    const raw = control.value || '';
    const value = raw.trim();

    if (!value) {
      return { required: true };
    }

    if (value.length > 50) {
      return { maxLength: true };
    }

    const validChars = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
    if (!validChars.test(value)) {
      return { invalidChars: true };
    }

    const words = value.split(/\s+/).filter(Boolean);
    if (words.length < 2) {
      return { minWords: true };
    }

    const first = words[0];
    const last = words[words.length - 1];

    if (first.length < 3) {
      return { firstWordShort: true };
    }

    if (last.length < 3) {
      return { lastWordShort: true };
    }

    return null;
  }

  cardNumberValidator(control: AbstractControl): ValidationErrors | null {
    const digits = String(control.value || '').replace(/\D/g, '');

    if (!digits) {
      return null;
    }

    if (digits.length < 15) {
      return { minlength: true };
    }

    if (digits.length > 19) {
      return { maxlength: true };
    }

    if (!/^\d{15,19}$/.test(digits)) {
      return { pattern: true };
    }

    return null;
  }

  luhnValidator(control: AbstractControl): ValidationErrors | null {
    const value = String(control.value || '').replace(/\D/g, '');

    if (!value) {
      return null;
    }

    if (value.length < 15 || value.length > 19) {
      return null;
    }

    let sum = 0;
    let shouldDouble = false;

    for (let i = value.length - 1; i >= 0; i--) {
      let digit = parseInt(value[i], 10);

      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) {
          digit -= 9;
        }
      }

      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0 ? null : { luhn: true };
  }

  send(){
    console.log('=== [send] INICIO ===');
    console.log('[send] signedID:', this.signedID);
    console.log('[send] token:', this.token);
    console.log('[send] HOST:', this.HOST);

    if (this.basicForm.invalid) {
      this.basicForm.markAllAsTouched();
      return;
    }

    this.spinner.open();

    // Datos de tarjeta a cifrar
    const creditCardData = {
      numberCreditCard : String(this.basicForm.value.numberCreditCard || '').replace(/\D/g, ''),
      nameHolderCreditCard : this.basicForm.value.nameHolderCreditCard,
      expMonthCreditCard : this.basicForm.value.expMonthCreditCard,
      expYearCreditCard : this.basicForm.value.expYearCreditCard,
      ccv : this.basicForm.value.ccv
    };

    console.log('[send] Cifrando datos de tarjeta con RSA...');

    // Cifrar datos de tarjeta con RSA
    this.rsaEncryption.encrypt(creditCardData, this.HOST).subscribe({
      next: (encryptedCreditCard) => {
        console.log('[send] Datos cifrados exitosamente');

        // Construir payload con creditcard cifrado
        const finalPayload = {
          creditcard: encryptedCreditCard,
          signedUrl: this.signedID,
          token: this.token,
          param: 9
        };

        console.log('[send] Enviando POST a:', this.HOST + "/suscription");

        // Enviar al backend
        this.call.post(finalPayload, this.HOST + "/suscription").subscribe(response =>{
      this.spinner.close();
        console.log('[send] Respuesta de /suscription recibida');
        console.log('[send] response COMPLETO:', JSON.stringify(response, null, 2));
        console.log('[send] response.htmlFormData presente:', !!response.htmlFormData);
        console.log('[send] response.id:', response.id);

        if(response.htmlFormData){
          console.log('[send] >>> FLUJO 3DS: Se recibió htmlFormData del banco');

          this.cc = response.id;
          console.log('[send] cc asignado:', this.cc);
          console.log('[send] Abriendo FacPopupComponent (MatDialog) con HTML del banco...');

          let dialogRef: MatDialogRef<any> = this.dialog.open(FacPopupComponent, {
            width: '50%',
            disableClose: true,
            data: { form: this.sanitizer.bypassSecurityTrustHtml(response.htmlFormData), process: this.cc }
          })
          dialogRef.afterClosed()
            .subscribe(res => {
              console.log('[send] Dialog cerrado. Resultado:', res);
              console.log('[send] Invocando myLoadEvent() después de cerrar dialog 3DS');
              this.myLoadEvent();
            })

        }else{
          console.log('[send] >>> FLUJO DIRECTO (sin 3DS): No se recibió htmlFormData');
          console.log('[send] Invocando myLoadEvent() directamente');
          this.myLoadEvent();


        }

        if(this.merchantUrl != null){ // SOLO ENVIAMOS LA RESPUESTA EN CASO DE QUE EL CLIENTE TENGA UNA URL DE RETORNO
          console.log('[send] merchantUrl presente:', this.merchantUrl);
          console.log('[send] Preparando redirect con json y signature de response');
          this.jsonEncoded = response.json;
          this.signatureCalculated = response.signature;
          jQuery('#Ds_MerchantParameters').val(this.jsonEncoded);
          jQuery('#Ds_Signature').val(this.signatureCalculated);
          console.log('[send] Ejecutando submit hacia merchantUrl:', this.merchantUrl);
          jQuery('#formid').attr('action', this.merchantUrl).submit();

        } else {
          console.log('[send] Sin merchantUrl en este punto - no se redirige');
        }

      }, err =>{
        console.error('[send] >>> ERROR en POST /suscription:', err);
        this.spinner.close();

        this.confirmService.confirm({title: 'ERROR', message: err})
          .subscribe((result) => {

            if(result){ // SI LA RESPUESTA ES OK - Eliminamos el registro
              console.log('[send] Usuario confirmó OK en diálogo de error');
            }

            this.cdr.markForCheck();
          });

      });
      },
      error: (err) => {
        console.error('[send] >>> ERROR al cifrar datos de tarjeta:', err);
        this.spinner.close();
        this.confirmService.confirm({title: 'ERROR', message: 'Error al procesar datos de seguridad'})
          .subscribe((result) => {
            this.cdr.markForCheck();
          });
      }
    });

    console.log('[send] Proceso de cifrado iniciado, esperando respuesta...');
  }


  myLoadEvent(){
    console.log('=== [myLoadEvent] INICIO ===');
    console.log('[myLoadEvent] signedID:', this.signedID);
    console.log('[myLoadEvent] reference:', this.reference);
    console.log('[myLoadEvent] plan:', this.plan);

    let json : any = {};
    json.reference = this.reference;
    json.plan = this.plan;

    const url = this.call.HOST + "/signedUrl/" + this.signedID;
    console.log('[myLoadEvent] GET a:', url);

    this.call.get(url).subscribe(signed =>{
      console.log('[myLoadEvent] Respuesta recibida de /signedUrl');
      console.log('[myLoadEvent] signed.result:', JSON.stringify(signed.result));
      console.log('[myLoadEvent] result3DS:', signed.result.result3DS);
      console.log('[myLoadEvent] rejectionReason:', signed.result.rejectionReason);
      console.log('[myLoadEvent] merchantUrl:', signed.result.merchantUrl);
      console.log('[myLoadEvent] jsonEncoded presente:', !!signed.result.jsonEncoded);
      console.log('[myLoadEvent] signatureCalculated presente:', !!signed.result.signatureCalculated);

      this.jsonEncoded = signed.result.jsonEncoded;
      this.signatureCalculated = signed.result.signatureCalculated;
      this.clientForm.controls['Ds_MerchantParameters'].setValue(signed.result.jsonEncoded);
      this.clientForm.controls['Ds_Signature'].setValue(signed.result.signatureCalculated);

      if(signed.result.result3DS){
        console.log('[myLoadEvent] >>> FLUJO ÉXITO: result3DS es truthy - Registro procesado correctamente');

        this.confirmService.confirm({title: 'Exito', message: "Registro procesado correctamente"})
        .subscribe((result) => {
          console.log('[myLoadEvent] Usuario respondió al diálogo de éxito:', result);

          if(result){ // SI LA RESPUESTA ES OK - Eliminamos el registro
            console.log('[myLoadEvent] Usuario confirmó OK en éxito');
          }

          this.cdr.markForCheck();

        });

      } else if(signed.result.rejectionReason != null){
        console.log('[myLoadEvent] >>> FLUJO RECHAZO: rejectionReason:', signed.result.rejectionReason);

        this.confirmService.confirm({title: 'ERROR', message: signed.result.rejectionReason})
        .subscribe((result) => {
          console.log('[myLoadEvent] Usuario respondió al diálogo de error:', result);

          if(result){ // SI LA RESPUESTA ES OK - Eliminamos el registro
            console.log('[myLoadEvent] Usuario confirmó OK en error');
          }

          this.cdr.markForCheck();
        });

      } else {
        console.log('[myLoadEvent] >>> FLUJO PENDIENTE: Sin result3DS ni rejectionReason');
        console.log('[myLoadEvent] signed.result completo:', signed.result);
        this.cdr.markForCheck();
      }

      if(signed.result.merchantUrl != null){ // SOLO ENVIAMOS LA RESPUESTA EN CASO DE QUE EL CLIENTE TENGA UNA URL DE RETORNO
        console.log('[myLoadEvent] >>> REDIRECT: merchantUrl presente:', signed.result.merchantUrl);

        this.merchantUrl = signed.result.merchantUrl;
        jQuery('#Ds_MerchantParameters').val(this.jsonEncoded);
        jQuery('#Ds_Signature').val(this.signatureCalculated);
        console.log('[myLoadEvent] Ejecutando submit del formulario hacia:', this.merchantUrl);
        jQuery('#formid').attr('action', this.merchantUrl).submit();

      } else {
        console.log('[myLoadEvent] Sin merchantUrl - no se redirige al cliente');
      }

      console.log('=== [myLoadEvent] FIN ===');

    }, err=>{
      console.error('[myLoadEvent] >>> ERROR en GET /signedUrl:', err);
    })

   }

  onlyNumberKey(event : any){
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  sanitizeOnlyNumbers(event: any): void {
    const input = event.target as HTMLInputElement;
    if (!input) {
      return;
    }

    const sanitized = input.value.replace(/\D/g, '');
    const controlName = input.getAttribute('formControlName');
    const control = controlName ? this.basicForm.get(controlName) : null;

    input.value = sanitized;
    control?.setValue(sanitized, { emitEvent: false });
  }

  formatCardNumber(event: any): void {
    const input = event.target as HTMLInputElement;
    const control = this.basicForm.get('numberCreditCard');

    if (!input || !control) {
      return;
    }

    const originalCursor = input.selectionStart || 0;
    const originalValue = input.value;
    const raw = originalValue.replace(/\D/g, '').substring(0, 19);
    const formatted = raw.replace(/(\d{4})(?=\d)/g, '$1-');
    const digitsBeforeCursor = originalValue.slice(0, originalCursor).replace(/\D/g, '').length;
    const newCursorPosition = raw
      .slice(0, digitsBeforeCursor)
      .replace(/(\d{4})(?=\d)/g, '$1-')
      .length;

    control.setValue(formatted, { emitEvent: false });
    input.value = formatted;

    setTimeout(() => input.setSelectionRange(newCursorPosition, newCursorPosition));
  }

}
